export default "__VITE_ASSET__CVFXvbtO__"